/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/10/13
 * Time: 10:34 AM
 * This is used for registering new dictionaries in the framework
 */
define({
    dictionaries:[
        {
            "name":"LEUIComponents",
            "path":"assets/ui-components/i18n/"

        },
        {
            "name":"LEFramework",
            "path":"src/i18n/"
        }
    ]
});
